import { useEffect, useState } from "react";
import Form from "../../../../components/form/Form";
import { useHub, usePreferences } from "../../../../core/Global";
import { toastSuccess } from "../../../../components/base/Toast";
import Icon from "../../../../components/base/Icon";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";
import TextArea from "../../../../components/form/TextArea";
import FlexRow from "../../../../components/base/FlexRow";
import TextBox from "../../../../components/form/TextBox";



export default function AutomaticSmsSettings() {

    const hub = useHub()
    const pref = usePreferences()
    const [working, workingSet] = useState<boolean>(false)

    useEffect(() => {
        if (pref) {
            autoAddJobTextToCustSet(pref.autoMessagingSettings.autoAddJobTextToCust)
            autoFeedbackTextToCustSet(pref.autoMessagingSettings.autoFeedbackTextToCust)
            autoNotifyApptToCustSet(pref.autoMessagingSettings.autoNotifyApptToCust)
            autoNotCalledReminderSet(pref.autoMessagingSettings.autoNotCalledReminder)
            autoNotifyApptToCustMinutesSet(pref.autoMessagingSettings.autoNotifyApptToCustMinutes)
            autoNotCalledReminderMinutesSet(pref.autoMessagingSettings.autoNotCalledReminderMinutes)
        }
    }, [pref])

    const [autoAddJobTextToCust, autoAddJobTextToCustSet] = useState<boolean>(false)
    useEffect(() => {
        if (autoAddJobTextToCust) setTimeout(() => {
            $("#txt-autoAddJobTextToCustText").focus();
        }, 300);
    }, [autoAddJobTextToCust])


    const [autoFeedbackTextToCust, autoFeedbackTextToCustSet] = useState<boolean>(false)
    useEffect(() => {
        if (autoFeedbackTextToCust) setTimeout(() => {
            $("#txt-autoFeedbackTextToCustText").focus();
        }, 300);
    }, [autoFeedbackTextToCust])

    const [autoNotifyApptToCust, autoNotifyApptToCustSet] = useState<boolean>(false)
    useEffect(() => {
        if (autoNotifyApptToCust) setTimeout(() => {
            $("#txt-autoNotifyApptToCustText").focus();
        }, 300);
    }, [autoNotifyApptToCust])


    const [autoNotCalledReminder, autoNotCalledReminderSet] = useState<boolean>(false)
    useEffect(() => {
        if (autoNotCalledReminder) setTimeout(() => {
            $("#txt-autoNotCalledReminderText").focus();
        }, 300);
    }, [autoNotCalledReminder])




    const [autoNotifyApptToCustMinutes, autoNotifyApptToCustMinutesSet] = useState<number>(60)
    const [autoNotCalledReminderMinutes, autoNotCalledReminderMinutesSet] = useState<number>(15)


    return (
        <Form className="form"
            onSubmit={(body, callback) => {
                workingSet(true);
                hub.Post("/system/Settings/autosmsrules", {
                    ...body,
                    autoAddJobTextToCust,
                    autoFeedbackTextToCust,
                    autoNotifyApptToCust,
                    autoNotCalledReminder,
                    autoNotifyApptToCustMinutes,
                    autoNotCalledReminderMinutes
                }, res => {
                    if (res.success) {
                        toastSuccess("Auto messaing rules has been updated successfully!");
                    }
                    if (callback) callback(res);
                    workingSet(false);
                });
            }}>
            <div className="card mb-5">
                <div className="card-header border-0">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                            Auto Messaging Rules
                        </h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    : <>Update Settings</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top px-9 pt-10 pb-4">

                    <ToggleSwitch label="Automatically send a message to the customer once their job is added to the system!"
                        raw small className="mb-5"
                        checked={autoAddJobTextToCust}
                        onChange={e => autoAddJobTextToCustSet(e)} />
                    {
                        autoAddJobTextToCust &&
                        <TextArea id="txt-autoAddJobTextToCustText" key="txt-autoAddJobTextToCustText" noMarginBottom
                            name="autoAddJobTextToCustText" rows={4} placeholder="Write a message..." block value={pref?.autoMessagingSettings.autoAddJobTextToCustText}
                        />
                    }

                    <hr className="my-10" />

                    <ToggleSwitch label="Automatically send a message to the customer after the job is closed to collect feedback!"
                        raw small className="mb-5"
                        checked={autoFeedbackTextToCust}
                        onChange={e => autoFeedbackTextToCustSet(e)} />
                    {
                        autoFeedbackTextToCust &&
                        <TextArea id="txt-autoFeedbackTextToCustText" key="txt-autoFeedbackTextToCustText" noMarginBottom
                            name="autoFeedbackTextToCustText" rows={4} placeholder="Write a message..." block value={pref?.autoMessagingSettings.autoFeedbackTextToCustText}
                        />
                    }

                    <hr className="my-10" />

                    <ToggleSwitch label="Automatically notify the customer before the appointment time!"
                        raw small className="mb-5"
                        checked={autoNotifyApptToCust}
                        onChange={e => autoNotifyApptToCustSet(e)} />
                    {
                        autoNotifyApptToCust &&
                        <div>
                            <TextArea id="txt-autoNotifyApptToCustText" key="txt-autoNotifyApptToCustText" marginBottom={5}
                                name="autoNotifyApptToCustText" rows={4} placeholder="Write a message..." block value={pref?.autoMessagingSettings.autoNotifyApptToCustText}
                            />

                            <div className="w-250px">
                                <TextBox label="" block iconText="Minutes Before" name="autoNotifyApptToCustMinutes"
                                    numeric maxLength={3} value={autoNotifyApptToCustMinutes}
                                    onTextChanges={e => autoNotifyApptToCustMinutesSet(Number.parseInt(e))} />
                            </div>

                        </div>
                    }

                    <hr className="my-10" />

                    <ToggleSwitch label="Automatically notify the technician if no call is made to the customer!"
                        raw small className="mb-5"
                        checked={autoNotCalledReminder}
                        onChange={e => autoNotCalledReminderSet(e)} />

                    {
                        autoNotCalledReminder &&
                        <div className="mb-10">
                            <TextArea id="txt-autoNotCalledReminderText" key="txt-autoNotCalledReminderText" noMarginBottom
                                name="autoNotCalledReminderText" rows={4} placeholder="Write a message..." block value={pref?.autoMessagingSettings.autoNotCalledReminderText}
                            />
                            <FlexRow className="text-muted mt-1 mb-5">
                                <Icon icon="info-circle" size={10} />
                                <span className="fs-8 ms-1">
                                    Job details will automatically add to your reminder text!
                                </span>
                            </FlexRow>

                            <div className="w-300px">
                                <TextBox label="" block iconText="Minutes After Job Accepted!"
                                    numeric maxLength={3} value={autoNotCalledReminderMinutes}
                                    onTextChanges={e => autoNotCalledReminderMinutesSet(Number.parseInt(e))} />
                            </div>
                        </div>
                    }




                </div>
            </div>
        </Form>
    )
}